import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
// import FormComponent from '../FormComponent';
import TextField from '@mui/material/TextField';
import { useStore } from '../../context/appContext';
import validateOTP from '../../utils/validateOTP';
import _ from 'lodash';
import Button from '../Button';
import getOperationData from '../../apis/getOperationData';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import BankLogo from '../../assets/img/BankLogo.png';
import { IconButton, InputAdornment } from '@mui/material';
import { modalTypes } from '../../context/types';


const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const DniContainer = styled.div`
  grid-area: number;
`;

const OtpContainer = styled.div`
  grid-area: phone;
`;

const Label = styled.h5`
  font-size: 1.05rem;
  text-align: left;
  color: gray;
  margin: 20px 0 0 0;
`;

const ImgDiv = styled.div`
  grid-area: content;
  display: inline-grid;
  justify-items: center;
  align-items: center;
`;

const Img = styled.img`
  width: 100%;
`;

const formDataInitialDefaults = {
  document: '',
  token: ''
};

function FirstForm() {
  const { stepForward, setOperationData, setModal, notificate, setError, setLoading } = useStore();
  const [viewPassword, setViewPassword] = useState(false);

  const {
    user: { document, token },
  } = useStore();

  const formDataInitialState = _.merge({}, formDataInitialDefaults, {
    document: document,
    token: token
  });

  const [formData, setFormData] = useState(formDataInitialState);
  const [errors, setErrors] = useState(validateOTP(formData));

  const handleGetByHash = async () => {
    setLoading(true);
    const response = await getOperationData(setOperationData, { document: formData.document, token: formData.token }, setError);
    if (response.error === 'invalid_document') {
      setModal({
        open: true,
        type: modalTypes.documentFailed,
      });
      setLoading(false);
      return
    };
    if (response.error === 'invalid_otp') {
      setModal({
        open: true,
        type: modalTypes.otpFailed,
      });
      setLoading(false);
      return
    };

    notificate.operationId = response && response.operationId;

    if (response) {
      setModal({
        open: true,
        type: modalTypes.loginSuccess,
      });
      setLoading(false);
      stepForward();
    };

    return response;
  };



  const handleChange = (e) => {
    setErrors(
      validateOTP({ ...formData, [e.target.id]: e.target.value }));
    setFormData(
      { ...formData, [e.target.id]: e.target.value });
  };

  const handleClickShowPassword = () => {
    setViewPassword(!viewPassword);
  };

  useEffect(() => {
    setFormData({ ...formData, validate: errors.validate })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors.validate]);

  return (
    <FormContainer>
      <ImgDiv>
        <Img src={BankLogo} />
      </ImgDiv>
      <Label>¡Bienvenido!</Label>
      <Label>Por favor ingrese su número de documento y su contraseña para poder validar su identidad.</Label>
      <DniContainer>
        <Label>Número de Documento*</Label>
        <TextField
          error={!!errors.document}
          helperText={errors.document}
          hiddenLabel
          variant="outlined"
          defaultValue={formData.document}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="document"
          style={{ backgroundColor: 'white' }}
        />
      </DniContainer>
      <OtpContainer>
        <Label>Contraseña*</Label>
        <TextField
          error={!!errors.token}
          helperText={errors.token}
          hiddenLabel
          variant="outlined"
          defaultValue={formData.token}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="token"
          style={{ backgroundColor: 'white' }}
          type={viewPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
              >
                <IconButton>
                  {viewPassword ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
            // className: classes.input,
            // autoComplete: 'off',
          }}
        />
      </OtpContainer>
      <Button filled grid="buttons" onClick={handleGetByHash}>
        Continuar
      </Button>
    </FormContainer>
  );
}

export default FirstForm;
